import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import Navbar from './components/Navbar';
import PasswordRecovery from './pages/email/PasswordRecovery';
import Login from './pages/Login';
import CustomRoutes from './Routes';
import './styles/App.scss';
import Test from './Test';
import { apiGet, destroySession, getSession, storeSession } from './utils/api';


export default function App(props) {
    const [usuario, setUsuario] = useState(getSession());
    const [isError, setIsError] = useState(false);
    const [navigateHome, setNavigateHome] = useState(false);

    const locationPath = useLocation().pathname;
    const isMinNavbar = window.ENV.Test || isError || !usuario ||
        locationPath.startsWith("/email");
    const isPasswordRecovery = locationPath.startsWith("/email/reestablecercontrasena");

    useEffect(() => { if (usuario) getUsuario(); }, []);
    useEffect(() => { setNavigateHome(false); });

    /********** session **********/

    const updateUsuario = value => {
        setUsuario(value);
        setIsError(false);
        if (value) {
            storeSession(value);
        } else {
            destroySession();
            setNavigateHome(true);
        }
    }

    const logout = () => {
        apiGet("sesion/logout");
        updateUsuario(null);
    }

    const getUsuario = async () => {
        if (!isPasswordRecovery) {
            const session = await apiGet("sesion/get");
            updateUsuario(session);
        }
    }

    /********** render **********/

    const rRoutes = () => <div className="App"><CustomRoutes /></div>;
    const rLogin = <div className="App"><Login onLogin={updateUsuario} /></div>;
    const rNavigate = <Navigate to="/" />;
    const rTest = <Test method="" url="" body={{}} />;
    const rPasswordRecovery = <div className="App"><PasswordRecovery token={locationPath.split('/')[3]} /></div>;

    return <>
        {isMinNavbar ? <Navbar min /> :
            <Navbar onLogout={logout}
                nombre={usuario.username}
                admin={usuario.permisoAdmin}
                validacion={usuario.permisoValidacion}
                vestuario={usuario.permisoVestuario} />
        }
        {window.ENV.Test ? rTest :
            !isError && (navigateHome ? rNavigate :
                usuario ? rRoutes() :
                    isPasswordRecovery ? rPasswordRecovery : rLogin)}
    </>;
}
